import React, { useState } from 'react';
import { Box, Button, Typography, Alert, CircularProgress } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import { contractProcessingService } from '../services/api';

function OfferUpload({ onFileProcessed }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
    if (!allowedTypes.includes(file.type)) {
      setError('Please upload a PDF or image file (JPG, PNG)');
      return;
    }

    setUploading(true);
    setError('');

    try {
      const extractedData = await contractProcessingService.extractOfferData(file);
      onFileProcessed(extractedData);
    } catch (error) {
      console.error('Upload error:', error);
      setError('Error processing file. Please try again.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      
      <input
        accept=".pdf,.jpg,.jpeg,.png"
        style={{ display: 'none' }}
        id="offer-file-upload"
        type="file"
        onChange={handleFileUpload}
        disabled={uploading}
      />
      
      <label htmlFor="offer-file-upload">
        <Button
          variant="outlined"
          component="span"
          startIcon={uploading ? <CircularProgress size={20} /> : <CloudUpload />}
          disabled={uploading}
          sx={{ mb: 1 }}
        >
          {uploading ? 'Processing...' : 'Upload Offer Document'}
        </Button>
      </label>
      
      <Typography variant="body2" color="text.secondary">
        Supported formats: PDF, JPG, PNG
      </Typography>
    </Box>
  );
}

export default OfferUpload;